import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AppModule } from '../models';
import { PlanService } from '../services/plan.service';

/** Rota só abre se o plano da loja incluir o módulo; senão vai para "Meu plano". */
export const moduleGuard = (module: AppModule): CanActivateFn => () => {
  const plans = inject(PlanService);
  const router = inject(Router);
  return plans.hasModule$(module).pipe(
    map((ok) => ok || router.createUrlTree(['/meu-plano'], { queryParams: { recurso: module } })),
  );
};
